import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const SectionTitle = styled.div`
  ${tw`text-xl text-black font-bold mb-2`}
`;

export const ColorTitle = styled.div`
  ${tw`text-base text-gray7 font-semibold truncate`}
`;
export const ColorsRaw = styled.div`
  ${tw`flex gap-1`}
`;

export const ModalColorsContainer = styled.div<{
  $isActive?: boolean;
  $withSpace?: boolean;
}>`
  ${tw`flex flex-col gap-2 mb-2`}

  ${({
    $withSpace
  }) => $withSpace && tw`p-1 border rounded-lg mb-3`}

  ${({
    $isActive
  }) => ($isActive
    ? tw`border-button-blue shadow-active-theme`
    : tw`border-gray94 shadow-card-invite`)}
`;

export const ModalColorCard = styled.div<{ $bgColor: string }>`
  ${tw`h-36 flex-1 rounded shadow-card-invite p-2 flex flex-col justify-between`}

  ${({
    $bgColor
  }) => `
    background-color: ${$bgColor};
  `}
`;

export const ModalColorCardTitle = styled.div<{ $isBig?: boolean }>`
  ${tw`p-1 rounded bg-white06 font-medium text-gray7 min-w-32px text-center`}

  ${({
    $isBig
  }) => ($isBig ? tw`text-base` : tw`text-xs leading-5`)}
`;
